import React, { useState } from 'react';
import { Plus } from 'lucide-react';

export interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}

interface FAQProps {
  title?: string;
  faqs: {
    question: string;
    answer: string;
  }[];
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer, isOpen, onClick }) => (
  <div className="relative w-full bg-white overflow-hidden border border-solid border-nileBlueLight mb-3 rounded-[15px] rounded-b-none">
    <button 
      className="relative flex justify-between items-center text-left bg-white top-0 left-0 w-full outline-none text-black focus-visible:bg-shade100 p-5 [&_svg]:text-[#F47B20] [&_svg]:transition-transform [&_svg]:duration-150 [&_svg]:ml-4"
      onClick={onClick}
      aria-expanded={isOpen}
    >
      <span className="text-black leading-[1.56] text-[16px] md:text-[18px] font-normal w-[calc(100%-2rem)]">
        {question}
      </span>
      <Plus className={`transition-transform duration-150 ${isOpen ? 'rotate-45' : ''}`} />
    </button>
    <div 
      className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px]' : 'max-h-0'} overflow-hidden`}
    >
      <div className="px-5 pb-5">
        <p className="text-base leading-[1.56]">{answer}</p>
      </div>
    </div>
  </div>
);

function FAQ({ title = "Vraag en antwoord", faqs }: FAQProps) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-16">
      <div className="mx-auto md:max-w-[520px] lg:max-w-[100vw]">
        <div className="font-bold text-black leading-[1.25] text-[20px] lg:text-[28px] mb-6">
          {title}
        </div>
        <div className="grid auto-rows-auto lg:gap-x-8 lg:grid-cols-[1fr_1fr]">
          <div>
            {faqs.slice(0, 3).map((faq, index) => (
              <FAQItem
                key={index}
                question={faq.question}
                answer={faq.answer}
                isOpen={openIndex === index}
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
              />
            ))}
          </div>
          <div>
            {faqs.slice(3).map((faq, index) => (
              <FAQItem
                key={index + 3}
                question={faq.question}
                answer={faq.answer}
                isOpen={openIndex === index + 3}
                onClick={() => setOpenIndex(openIndex === index + 3 ? -1 : index + 3)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ;